// extracted by mini-css-extract-plugin
export var searchHeader = "_25-0";
export var searchHeaderDark = "_25-1";